import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  constructor() { }
  behaviorSubj = new BehaviorSubject("");
  unReadInternationalOrderNotificationCount = new BehaviorSubject<number>(0);
  recallInternationalOrderList = new BehaviorSubject(false);
}
